import { isInProgress } from "App/apiMiddleware";
import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getLastSaveFileUrl = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].lastSaveFileUrl`), (lastSaveFileUrl) => lastSaveFileUrl);
export const getVoiceRecognition = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].voiceRecognition`), (voiceRecognition) => voiceRecognition !== null && voiceRecognition !== void 0 ? voiceRecognition : undefined);
export const InProgressFileSave = (state) => isInProgress(state, actionTypes.SAVE_FILE);
export const InProgressVoiceRecognition = (state) => isInProgress(state, actionTypes.API_VOICE_RECOGNITION);
